import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

import { SharePropertySource } from '@shared/models/share';

@Component({
  selector: 'app-property-share-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.scss'],
})
export class PropertyShareCopyLinkComponent {
  @Input({ required: true }) propertyUrl: string = '';
  @Output() shareAPI = new EventEmitter<SharePropertySource>();

  protected copied = false;

  constructor(
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef
  ) {}

  copyValue() {
    this.shareAPI.emit('DIRECT_LINK');
    this.clipboard.copy(this.propertyUrl);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
      this.cdr.detectChanges();
    }, 3000);
  }
}
